import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IWorkbookUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { IWorkbook } from '../types/IWorkbook';
import { INamedItem, ITypedItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetWorkbooksParams extends IGetItemsParams {
}

export interface IGetWorkbooksResult extends IGetItemsResult {
  workbooks?: IWorkbook[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  maxStats?: IWorkbookUsageInfo;
  favorites?: string[];
}

export class GetWorkbooksRequest extends Request<IGetWorkbooksParams, IGetWorkbooksResult> {
  constructor(params: IGetWorkbooksParams) {
    super('getWorkbooks', params);
  }
}
